import cx from 'classnames';
import React from 'react';
export const FormLabel = ({ caption, children, disabled, className, is: Tag = 'label', tooltip, ...rest }) => {
    const commonProps = {
        className: cx('tds-form-label', { 'tds--disabled': disabled }, className),
    };
    return (React.createElement(React.Fragment, null,
        tooltip ? (React.createElement("div", { ...commonProps },
            React.createElement(Tag, { className: "tds-form-label-text", ...rest }, children),
            !!tooltip && React.createElement(React.Fragment, null,
                " ",
                tooltip))) : (React.createElement(Tag, { ...commonProps, ...rest }, children)),
        caption && React.createElement("div", { className: "tds-form-caption" }, caption)));
};
